export function deviationHasFileSizeMetadata(deviation) {
    var _a;
    var file = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.originalFile;
    return !!(file && file.filesize && file.width && file.height);
}
//# sourceMappingURL=helpers.js.map